import __request__ from 'routing/request';
type ReportFrontendService__ReportingWidgetResultArray = ReportFrontendService__ReportingWidgetResult[];
interface ExecutionState {
    readonly parameter_bindings: {
        readonly [_key: string]: Parameter__Binding;
    };
    readonly global_override: ExecutionStateGlobalOverride;
    readonly additional_parameters: {
        readonly [_key: string]: Object;
    };
    readonly cancel_after_seconds: number;
    readonly queries: {
        readonly [_key: string]: ExecutionStateGlobalOverride;
    };
}
interface CreateEntityRequest_ReportRequest {
    readonly entity: ReportRequest;
    readonly share_request: EntityShareRequest;
}
interface ReportFrontendService__ReportingWidgetResult {
    readonly result: WidgetValueSummary;
    readonly widget_id: string;
    readonly dashboard_id: string;
}
interface FilterOption {
    readonly title: string;
    readonly value: string;
}
interface Parameter__Binding {
    readonly type: string;
}
interface WidgetConfigDTO {
}
interface ReportWidget {
    readonly dashboard_widget_id: string;
    readonly description: string;
    readonly title: string;
    readonly dashboard_id: string;
    readonly height: number;
}
interface ReportResponseShort {
    readonly delivery: ReportDelivery;
    readonly timezone: string;
    readonly parameter_values: {
        readonly [_key: string]: Parameter__Binding;
    };
    readonly description: string;
    readonly positions: ReportWidgetPosition[];
    readonly title: string;
    readonly widgets: ReportWidget[];
    readonly hide_widget_description: boolean;
    readonly layout: ReportLayout;
    readonly hide_widget_query: boolean;
    readonly subtitle: string;
    readonly logo: string;
    readonly id: string;
    readonly parameters: {
        readonly [_key: string]: Parameter;
    };
}
interface PageListResponse_ReportSummaryDTO {
    readonly total: number;
    readonly pagination: PaginatedList__PaginationInfo;
    readonly defaults: EntityDefaults;
    readonly query: string;
    readonly elements: ReportSummaryDTO[];
    readonly attributes: EntityAttribute[];
    readonly sort: string;
    readonly order: 'asc' | 'desc';
}
interface ReportResource__AdditionalReportingParameters {
    readonly time_range: TimeRange;
}
interface ReportWidgetReference {
    readonly widget_id: string;
    readonly description: string;
    readonly title: string;
    readonly dashboard_id: string;
    readonly height: number;
}
interface ReportFrequencyConfiguration {
    readonly timerange: TimeRange;
    readonly timezone: string;
    readonly override_widgets_timerange: boolean;
    readonly time: string;
    readonly day_of_month: string;
    readonly day_of_week: string;
}
interface ReportResponse {
    readonly delivery: ReportDelivery;
    readonly timezone: string;
    readonly parameter_values: {
        readonly [_key: string]: Parameter__Binding;
    };
    readonly description: string;
    readonly positions: ReportWidgetPosition[];
    readonly title: string;
    readonly widgets: ReportDashboardWidget[];
    readonly hide_widget_description: boolean;
    readonly layout: ReportLayout;
    readonly hide_widget_query: boolean;
    readonly subtitle: string;
    readonly id: string;
    readonly parameters: {
        readonly [_key: string]: Parameter;
    };
}
interface EntityShareRequest {
    readonly selected_grantee_capabilities: {
        readonly [_key: string]: 'view' | 'manage' | 'own';
    };
    readonly selected_collections: string[];
}
interface UnitId {
    readonly abbrev: string;
    readonly unit_type: string;
}
interface MappedFieldTypeDTO {
    readonly unit: UnitId;
    readonly name: string;
    readonly type: FieldTypes__Type;
}
interface PaginatedList__PaginationInfo {
    readonly per_page: number;
    readonly total: number;
    readonly count: number;
    readonly page: number;
}
interface ReportWidgetPosition {
    readonly col: number;
    readonly dashboard_widget_id: string;
    readonly row: number;
}
interface ReportLayout {
    readonly orientation: 'portrait' | 'landscape';
    readonly print_footer: boolean;
    readonly footer: string;
    readonly format: 'PDF' | 'CSV' | 'XLSX' | 'YML' | 'JSON' | 'XML';
    readonly header: string;
    readonly print_header: boolean;
    readonly print_page_numbers: boolean;
    readonly print_toc: boolean;
    readonly page_size: 'a4' | 'letter';
}
interface WidgetPositionDTO {
    readonly col: Position;
    readonly width: Position;
    readonly row: Position;
    readonly height: Position;
}
type stringArray = string[];
interface UsedSearchFilter {
}
interface DeliveryConfiguration {
    readonly frequency_configuration: ReportFrequencyConfiguration;
    readonly frequency: 'HOURLY' | 'DAILY' | 'WEEKLY' | 'MONTHLY';
}
interface EntityAttribute {
    readonly filterable: boolean;
    readonly related_property: string;
    readonly related_collection: string;
    readonly hidden: boolean;
    readonly sortable: boolean;
    readonly id: string;
    readonly type: 'STRING' | 'DATE' | 'DOUBLE' | 'INT' | 'LONG' | 'OBJECT_ID' | 'BOOLEAN';
    readonly title: string;
    readonly searchable: boolean;
    readonly filter_options: FilterOption[];
}
interface Position {
}
interface ReportResource__AdhocReportRequest {
    readonly execution_state: ExecutionState;
    readonly widgets: ReportWidgetReference[];
}
interface ReportRequest {
    readonly layout: ReportLayout;
    readonly hide_widget_query: boolean;
    readonly delivery: ReportDelivery;
    readonly timezone: string;
    readonly parameter_values: {
        readonly [_key: string]: Parameter__Binding;
    };
    readonly subtitle: string;
    readonly logo: string;
    readonly description: string;
    readonly positions: ReportWidgetPosition[];
    readonly title: string;
    readonly widgets: ReportWidgetReference[];
    readonly hide_widget_description: boolean;
}
interface ReportDeliveryRequest {
    readonly delivery: ReportDelivery;
}
interface ReportPositionsRequest {
    readonly positions: ReportWidgetPosition[];
}
interface ReportDashboardWidget {
    readonly creator_user_id: string;
    readonly cache_time: number;
    readonly dashboard_widget_id: string;
    readonly timerange: TimeRange;
    readonly query: BackendQuery;
    readonly streams: string[];
    readonly description: string;
    readonly filters: UsedSearchFilter[];
    readonly position: WidgetPositionDTO;
    readonly type: string;
    readonly config: WidgetConfigDTO;
    readonly dashboard_id: string;
}
interface ReportDelivery {
    readonly email_body: string;
    readonly scheduling: DeliveryConfiguration[];
    readonly active: boolean;
    readonly user_receivers: string[];
    readonly email_subject: string;
    readonly email_receivers: string[];
}
interface ReportSummaryDTO {
    readonly owner: string;
    readonly owner_full_name: string;
    readonly delivery: ReportDelivery;
    readonly widget_count: number;
    readonly timezone: string;
    readonly subtitle: string;
    readonly description: string;
    readonly created_at: string;
    readonly id: string;
    readonly title: string;
    readonly last_generated_at: string;
    readonly status: 'STARTING' | 'RUNNING' | 'RETRYING' | 'GENERATED' | 'FAILURE' | 'DELIVERING' | 'RETRYING_DELIVERY' | 'SUCCESS' | 'DELIVERY_FAILURE';
}
interface ExecutionStateGlobalOverride {
    readonly timerange: TimeRange;
    readonly keep_search_types: string[];
    readonly offset: number;
    readonly query: BackendQuery;
    readonly now: string;
    readonly limit: number;
    readonly search_types: {
        readonly [_key: string]: SearchTypeExecutionState;
    };
    readonly keep_queries: string[];
}
interface Sorting {
    readonly id: string;
    readonly direction: 'ASC' | 'DESC';
}
interface TimeRange {
    readonly type: string;
}
interface EntityDefaults {
    readonly sort: Sorting;
}
interface SearchError {
    readonly description: string;
}
interface WidgetValueSummary {
    readonly result: SearchType__Result[];
    readonly field_types: MappedFieldTypeDTO[];
    readonly calculated_at: string;
    readonly errors: SearchError[];
}
interface SearchTypeExecutionState {
    readonly per_page: number;
    readonly offset: number;
    readonly limit: number;
    readonly page: number;
    readonly after: unknown[];
}
interface FieldTypes__Type {
    readonly index_names: string[];
    readonly type: string;
    readonly properties: string[];
}
interface Parameter {
    readonly name: string;
    readonly data_type: string;
    readonly binding: Parameter__Binding;
    readonly description: string;
    readonly optional: boolean;
    readonly default_value: Object;
    readonly title: string;
    readonly type: string;
}
interface ReportConfiguration {
    readonly delivery: ReportDelivery;
    readonly timezone: string;
    readonly parameter_values: {
        readonly [_key: string]: Parameter__Binding;
    };
    readonly description: string;
    readonly created_at: string;
    readonly positions: ReportWidgetPosition[];
    readonly title: string;
    readonly widgets: ReportWidget[];
    readonly hide_widget_description: boolean;
    readonly layout: ReportLayout;
    readonly hide_widget_query: boolean;
    readonly subtitle: string;
    readonly logo: string;
    readonly id: string;
}
interface SearchType__Result {
    readonly name: string;
    readonly id: string;
    readonly type: string;
}
interface BackendQuery {
}
interface ReportList {
    readonly reports: ReportConfiguration[];
    readonly index: number;
}
/**
 * List all reports.
 */
export function list(): Promise<ReportList> {
    return __request__('GET', '/plugins/org.graylog.plugins.report/reports', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a report.
 */
export function create(JSONbody: CreateEntityRequest_ReportRequest): Promise<unknown> {
    return __request__('POST', '/plugins/org.graylog.plugins.report/reports', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Find reports referencing dashboard with specified id.
 */
export function byDashboardId(dashboardId: string): Promise<stringArray> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/byDashboard/${dashboardId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Find reports referencing widget with specified id.
 */
export function byWidgetId(dashboardId: string, widgetId: string): Promise<stringArray> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/byWidget/${dashboardId}/${widgetId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Find reports referencing any of the widgets with specified ids.
 */
export function byWidgetIds(dashboardId: string, JSONbody: stringArray): Promise<stringArray> {
    return __request__('POST', `/plugins/org.graylog.plugins.report/reports/byWidgets/${dashboardId}`, JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get existing reports paged
 * @param sort The field to sort the result on
 * @param order The sort direction
 */
export function reports(sort: 'id' | 'title' | 'created_at' | 'description' | 'summary' | 'owner' = 'title', page: number = 1, per_page: number = 50, order: 'asc' | 'desc' = 'asc', query?: string, filters?: stringArray): Promise<PageListResponse_ReportSummaryDTO> {
    return __request__('GET', '/plugins/org.graylog.plugins.report/reports/paginated', null, { 'page': page, 'per_page': per_page, 'sort': sort, 'order': order, 'query': query, 'filters': filters }, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieve values for ad-hoc report submitted.
 */
export function adhocReportValues(JSONbody: ReportResource__AdhocReportRequest): Promise<ReportFrontendService__ReportingWidgetResultArray> {
    return __request__('POST', '/plugins/org.graylog.plugins.report/reports/values', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get a single report.
 */
export function get(reportId: string): Promise<ReportResponse> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/${reportId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Update a report.
 */
export function update(reportId: string, JSONbody: ReportRequest): Promise<ReportResponse> {
    return __request__('PUT', `/plugins/org.graylog.plugins.report/reports/${reportId}`, JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Delete a report and all its widgets.
 */
export function remove(reportId: string): Promise<void> {
    return __request__('DELETE', `/plugins/org.graylog.plugins.report/reports/${reportId}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Update report delivery.
 */
export function updateDelivery(reportId: string, JSONbody: ReportDeliveryRequest): Promise<ReportResponse> {
    return __request__('PUT', `/plugins/org.graylog.plugins.report/reports/${reportId}/delivery`, JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Download a report instantly.
 */
export function downloadNow(reportId: string, filename: string, JSONbody?: ReportResource__AdditionalReportingParameters): Promise<unknown> {
    return __request__('POST', `/plugins/org.graylog.plugins.report/reports/${reportId}/downloadNow/${filename}`, JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Send report PDF as email
 */
export function sendReport(reportId: string): Promise<unknown> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/${reportId}/email`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Download a report instantly.
 */
export function generateReport(reportId: string, filename: string): Promise<unknown> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/${reportId}/generate/${filename}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get a report's logo.
 */
export function getLogo(reportId: string): Promise<unknown> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/${reportId}/logo`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Update widget positions of a report.
 */
export function updatePositions(reportId: string, JSONbody: ReportPositionsRequest): Promise<ReportResponse> {
    return __request__('PUT', `/plugins/org.graylog.plugins.report/reports/${reportId}/positions`, JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get a single report.
 */
export function getShort(reportId: string): Promise<ReportResponseShort> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/${reportId}/short`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get a single report as a summary.
 */
export function getSummary(reportId: string): Promise<ReportSummaryDTO> {
    return __request__('GET', `/plugins/org.graylog.plugins.report/reports/${reportId}/summary`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieve values for widgets referenced by report.
 */
export function reportValues(reportId: string, arg1?: ExecutionState): Promise<ReportFrontendService__ReportingWidgetResultArray> {
    return __request__('POST', `/plugins/org.graylog.plugins.report/reports/${reportId}/values`, arg1, {}, {
        'Accept': ['application/json']
    });
}
